import { NgIf, NgOptimizedImage } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { environment } from 'src/environments/environment';
import { CommonComponent } from '../../common/common.component';
import { PopupComponent } from '../popup/popup.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  // host: { ngSkipHydration: 'true' },
  imports: [NgIf, RouterLink, PopupComponent, NgOptimizedImage]
})
export class HeaderComponent extends CommonComponent implements OnInit {
  modalIsOpen = false;
  formValue = '';
  dashboard = environment.dashboard;
  isHoverMenu = false;

  // change header primary in secondary
  @Input() isPrimary = true;
  @Input() shadow = true;

  // redirect to home after click to header click
  @Input() redirectToHome = true;

  // INPUT GESTIONE IFRAME
  @Input() headerVisibility = false;
  @Input() order: number;
  @Input() isIframePage = false;

  // Evento cambio tipo
  @Output() searchTypeChanged = new EventEmitter<boolean>();

  constructor(
    public authenticationService: AuthenticationService,
    public main: AppComponent,
    private router: Router,
  ) {
    super(authenticationService);
  }

  ngOnInit(): void {
  }

  openPopup(): void {
    this.modalIsOpen = true;
  }

  closePopup(): void {
    this.modalIsOpen = false;
    this.formValue = 'accedi';
  }

  // Emit eventi link header
  async clickSearchType(id: string): Promise<void> {
    this.main.searchType = id;
    this.searchTypeChanged.emit();
    // GLOBAL VARIABLES FOR SEARCH
    this.main.searchType = 'agente';
    switch (id) {
      case 'agente':
        this.main.searchMethodType = 'name';
        this.main.searchType = 'agente';
        break;
      case 'vendita':
        this.main.searchMethodType = 'place';
        this.main.searchType = 'vendita';
        break;
      case 'affitto':
        this.main.searchMethodType = 'place';
        this.main.searchType = 'affitto';
        break;
    }

    if (this.redirectToHome) {
      await this.router.navigate(['']);
    }
  }

  linkBlank(url: string): void {
    window.open(url, '_blank');
  }
}


